<template>
  <div id="home">
    <div class="container-fluid" id="top-back-img">
      <div class="container">
        <div id="top-msg" class="text-center">
          <h2>Table Tennis Data Analysis</h2>
          <p>卓球を可視化する</p>
          <div class="mt-5">
            <b-button variant="outline-secondary" @click="$router.push('/analyze');">
              <span class="text-white">使ってみる</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-4 text-center">
          <div class="jumbotron bg-white shadow-sm">
            <h4 class="mt-3">自分を知る</h4>
            <p class="mt-5">自分の試合の振り返りに</p>
          </div>
        </div>
        <div class="col-lg-4 text-center">
          <div class="jumbotron bg-white shadow-sm">
            <h4 class="mt-3">相手を知る</h4>
            <p class="mt-5">対戦相手の特徴をつかむ</p>
          </div>
        </div>
        <div class="col-lg-4 text-center">
          <div class="jumbotron bg-white shadow-sm">
            <h4 class="mt-3">観戦をより楽しむ</h4>
            <p class="mt-5">試合をより理解する</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'home',
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
};
</script>

<style scoped>
#top-back-img{
  background-image: url("/static/img/top.jpg");
  margin-bottom: 32px;
  animation: bg-slider 100s linear infinite; /* 23sの部分背景画像の約数だとスムーズ */
}

@keyframes bg-slider {
  from { background-position: 0 0; }
    to { background-position: -1920px 0; } /* 1518pxとは使用した背景画像の長さ */
}

#top-msg{
  padding: 200px 0px 150px 0px;
  color: #eee;
}

.loading{
  margin: 200px 0px 150px 0px;
}

</style>



// WEBPACK FOOTER //
// src/views/Home.vue